export default __webpack_public_path__ + "4c27c3e03f8a6827d6b9f5619d53a3d2.svg";